<div class="flex flex-col gap-6">
  <div class="flex flex-col gap-4">
    @if (conflictingResourceValues().length) {
      <div class="text-sm/6">{{ subtitle() }}</div>

      @if (conflictingResourceValues().length > 1) {
        <flx-choice-group class="flx-ds radio-group flex-nowrap w-full">
          @for (option of applyToAllOptions; track option.value) {
            @let checked = applyToAllFC.value === option.value;

            <flx-radio
              [value]="option.value"
              [formControl]="applyToAllFC"
              [checked]="checked"
              [clear]="true"
              [attr.data-testId]="'radio-box-' + option.value"
              (change)="applySameOptionToAll(option.value)"
              class="w-full"
            >
              <flx-label class="font-normal">{{ option.label }}</flx-label>
            </flx-radio>
          }
        </flx-choice-group>
      }

      @for (
        conflictingResource of conflictingResourceValues();
        track conflictingResource.resourceDefinitionId
      ) {
        @let conflictingResourceFC = $any(conflictingResourcesFA.at($index));

        <flx-choice-group class="flx-ds radio-group flex-nowrap w-full">
          <flx-label class="flx-ds">
            <span>{{ conflictingResource.extendedName }}</span>
          </flx-label>

          @for (option of conflictingResource.options; track option.value) {
            @let checked = conflictingResourceFC.value === option.value;

            <flx-radio
              [value]="option.value"
              [formControl]="conflictingResourceFC"
              [checked]="checked"
              [clear]="true"
              [attr.data-testId]="'radio-box-' + conflictingResource.name + '-' + option.value"
              class="w-full"
            >
              <flx-label class="font-normal">{{ option.label }} </flx-label>
            </flx-radio>
          }
        </flx-choice-group>
      }
    }
  </div>
</div>
